import {Component, OnInit} from '@angular/core';
import {Guide} from '../../../models/guide';
import {UtilsService} from '../../../services/utils.service';
import {Router} from '@angular/router';
import {GuidesService} from '../../../services/guides.service';

@Component({
  selector: 'app-new-guide',
  templateUrl: './new-guide.component.html',
  styleUrls: ['./new-guide.component.scss']
})
export class NewGuideComponent implements OnInit {

  guide: Guide = new Guide();

  constructor(private guideService: GuidesService,
              private utilsService: UtilsService,
              private router: Router) {
  }

  ngOnInit() {

  }

  createGuide() {
    const requiredSuccess = this.utilsService.validateRequiredFields(this.guide.name);
    if (requiredSuccess) {
      this.guideService.createGuide(this.guide).subscribe((response) => {
        if (response.errors && response.errors.length > 0) {
          const errors = response.errors.map(err => err.message);
          this.utilsService.openSnackBar(errors, '');
        } else {
          this.utilsService.openSnackBar('Guide Created !!', '');
          this.router.navigate(['/guides']);
        }
      }, (error) => {
        this.utilsService.openSnackBar('Unable to create guide.', '');
        console.log('there was an error sending the query', error);
      });
    }
  }

}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/guides/new-guide/new-guide.component.ts